import { consoleWarn } from '@magnetic/lib';
import { createContext } from 'react';

const AnalyticsContext = createContext({
  sendAnalytics: () => {
    consoleWarn([
      {
        prop: true,
        message: "`analytics` prop set on component without function defined for `AnalyticsContext.Provider`."
      }
    ]);
  }
});

export { AnalyticsContext };
//# sourceMappingURL=analytics-context.js.map
